// extracted by mini-css-extract-plugin
export var base = "_2z-0";
export var updateBanner = "_2z-1";